let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gFEx7")).then(() => parcelRequire('j8C48'));